<template>
    <section class="tags-list">
        <h3 class="title is-2" v-if="title">{{ title }}</h3>

        <div class="badges-container">
            <template v-if="isLink">
                <router-link
                    v-if="tag"
                    v-for="(tag,index) in tags"
                    :key="tag.code+index"
                    :to="tag.route"
                    class="badge is-link"
                    :class="[tagStyle === 'red' ? brandBackgroundColor : null, 'style-'+tagStyle]"
                >
                    {{ tag.label }}
                </router-link>
            </template>
            <template v-else>
                <span
                    v-for="tag in tags"
                    :key="tag.code || tag"
                    class="badge"
                    :class="[tagStyle === 'red' ? brandBackgroundColor : null, 'style-'+tagStyle]"
                >
                    {{ tag.label || tag }}
                </span>
            </template>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'TagsList',
        props: {
          title: {
              type: String,
              required: false,
              default: () => []
          },
          tags: {
              type: Array,
              required: false,
              default: () => []
          },
          tagStyle: {
              type: String,
              required: false,
              default: 'red'
          }
        },
        computed: {
            isLink(){
                return (this.tags.length > 0 && this.$_.isObject(this.tags[0]) && this.tags[0].route);
            }
        }
    }
</script>

<style lang="scss">
.tags-list {
    .title {
        margin-bottom: 15px;
    }

    .badges-container {
        margin-left: -5px;

        .badge {
            display: inline-block;
            padding: 8px 12px;
            margin: 5px;
            font-size: 13px;
            letter-spacing: 0.9px;

            &.style-red {
                color: $white;
            }

            &.style-grey {
                border-radius: 24px;
                background-color: $light-grey;

                &:after {
                    @include icomoon;
                    content: "\e90e";
                    font-size: 10px;
                    margin-left: 7px;
                }

                &.is-link {
                    &:hover {
                        background-color: $black;
                        color: $white;
                    }
                }
            }
        }
    }
}
</style>
